// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609141604/js/" + chunkId + "." + {"44":"4ae2a34f","225":"5396059a","481":"fe09d667","486":"a0175113","770":"4c15b9ec"}[chunkId] + ".0.46828704525127585.chunk.js";
};